import Player from '@vimeo/player';

import globals from'../globals.js';

import load_image from'../helpers/image-loader.js';
import load_video from'../helpers/video-loader.js';

var swiperVimeoPlayers = [];


function isElementOnScreen(element) {

    const rect = element.getBoundingClientRect();
  
    const isVisible = rect.top >= (rect.height * -1) && rect.bottom <= (window.innerHeight + rect.height);
 
    const isHidden = window.getComputedStyle(element).display === 'none';
  
    return isVisible && !isHidden;
}

function checkElementsInViewport() {

    let loop = 0;


    swiperVimeoPlayers.forEach((obj) => {


        let element =  obj.elm;

        // console.log(isElementOnScreen(element), obj.playing);

        if (isElementOnScreen(element)) {

            if(!obj.loading && !obj.loaded){
                load_player(obj);
            }else{

                if(obj.loaded && !obj.playing && obj.player){
                    obj.player.play();
                }
                
            }

        }

    });

};

setInterval(function () { checkElementsInViewport() }, 1000);

function load_player(obj){
    var parent = obj.parent;
    bind_player(obj, false);
};


function swiper_player(){

    var players = document.querySelectorAll('.swiper-player');
    var videos = Array.prototype.slice.call(players);

    videos.forEach(function(vid) {

        var parent = vid.parentNode;
            
        if(!parent.classList.contains('swiper-slide')){
            var parent = vid.parentNode.parentNode;
        }

        var swiperVimeoPlayer = {
            elm: vid,
            id: vid.dataset.id,
            player: false,
            playing: false,
            parent: parent,
            loaded: false,
            loading: false
        };

        swiperVimeoPlayers.push(swiperVimeoPlayer);

        bind_player(swiperVimeoPlayer, false);
    
    });
    

    window.requestAnimationFrame(checker);

};

function bind_player(swiperVimeoPlayer, playing){

    if(!swiperVimeoPlayer.player){

        if(!swiperVimeoPlayer.loaded && !swiperVimeoPlayer.loading){
            
            swiperVimeoPlayer.loading = true;

            let autoplay = false;
            if(swiperVimeoPlayer.elm.classList.contains('autoplay')){
                autoplay = true;
            }

            const options = {
                id: swiperVimeoPlayer.id,
                responsive: false,
                playsinline: true,
                width: '1920px',
                height: '1080px',
                controls: false,
                muted: 1,
                loading: 'lazy',
                quality: '2k', 
                cache: true,
                dnt: true,
                loop: true
            };

            let elm = swiperVimeoPlayer.elm;
          
            if(swiperVimeoPlayer.elm.querySelector('video') && window.innerWidth < 900){
                
                let vid = swiperVimeoPlayer.elm.querySelector('video');
                vid.src = vid.dataset.src;
           
            }else{

                const player = new Player(swiperVimeoPlayer.elm, options);
                swiperVimeoPlayer.player = player;

                player.on("play", function(data) {
                    swiperVimeoPlayer.parent.classList.add('swiper-playing');
                    swiperVimeoPlayer.playing = true;
                });
    
                player.on("pause", function(data) {
                    swiperVimeoPlayer.playing = false;
                });
    
            }

            swiperVimeoPlayer.loaded = true;

        }

    }else{

        if(swiperVimeoPlayer.loaded){

         
            // if(playing){
            //     swiperVimeoPlayer.parent.classList.remove('swiper-playing');
            //     swiperVimeoPlayer.player.pause();
            // }else{
            //     swiperVimeoPlayer.parent.classList.add('swiper-playing');
            //     swiperVimeoPlayer.player.play();
            // }

        }

    }

}


function checker(){

    if(document.querySelector('.homepage-swiper')){


        for (let a = 0; a < swiperVimeoPlayers.length; a++) {

            let slide = swiperVimeoPlayers[a].parent;
            let swiperVimeoPlayer = swiperVimeoPlayers[a];

            if(slide.classList.contains('swiper-slide-active') || slide.classList.contains('swiper-slide-active') ){
                bind_player(swiperVimeoPlayer, false);
            }else{
                bind_player(swiperVimeoPlayer, true);
            }
                
        }

    }


    window.requestAnimationFrame(checker);
    
}




export default swiper_player;